import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  transloco = inject(TranslocoService);

  init() {
    const saved = localStorage.getItem('lang') || 'en';
    this.transloco.setActiveLang(saved);
  }

  setLang(lang: string) {
    this.transloco.setActiveLang(lang);
    localStorage.setItem('lang', lang);
  }
}
